"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliders = void 0;
const splide_1 = require("@splidejs/splide");
const customArrowPath = 'm24.44,35.11c-.57,0-1.14-.22-1.57-.65-.87-.87-.87-2.27,0-3.14l9.54-9.54H2.22c-1.23,0-2.22-1-2.22-2.22s1-2.22,2.22-2.22h30.19l-9.54-9.54c-.87-.87-.87-2.27,0-3.14s2.27-.87,3.14,0l13.33,13.33c.21.21.38.46.48.72.11.26.17.54.17.84h0c0,.31-.06.59-.17.85-.11.26-.27.51-.48.72l-13.33,13.33c-.43.43-1,.65-1.57.65Z';
const sliders = () => {
    let logos = document.getElementsByClassName('logos');
    for (let i = 0; i < logos.length; i++) {
        new splide_1.default(logos[i], {
            perPage: 1,
            type: 'loop',
            gap: '1.5rem',
            pagination: true,
            autoplay: true,
            arrows: false,
            mediaQuery: 'min',
            breakpoints: {
                767: {
                    destroy: true,
                },
            }
        }).mount();
    }
    let testimonials = document.getElementsByClassName('testimonials-carousel');
    for (let i = 0; i < testimonials.length; i++) {
        new splide_1.default(testimonials[i], {
            arrowPath: customArrowPath,
            perPage: 1,
            type: 'loop',
            gap: '1.5rem',
            pagination: true,
            autoplay: true,
            arrows: true,
        }).mount();
    }
    let imageCarousel = document.getElementsByClassName('image-carousel');
    for (let i = 0; i < imageCarousel.length; i++) {
        new splide_1.default(imageCarousel[i], {
            perPage: 1,
            type: 'loop',
            gap: '4rem',
            pagination: true,
            autoplay: true,
            arrows: false,
        }).mount();
    }
};
exports.sliders = sliders;
